import number from './number'

export default function currency(value, locale, options = {}) {
  return number(value, locale, {
    style: 'currency',
    currency: 'EUR',
    ...options
  })
}
